import BeforeAfterPhotosContainer from 'components/Shared/BeforeAfter/BeforeAfterPhotosContainer';
import { useTranslation } from 'hooks/useTranslation';
import { RecordType } from 'types/BeforeAfterPhotos';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';

type Props = {
  beforeAfterPhotos: APIBeforeAfterPhoto[];
  baPhotosTotalCount?: string | number;
  slug: string;
};

const BeforeAfterPhotosSection = ({
  beforeAfterPhotos,
  baPhotosTotalCount,
  slug,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <section>
      <div className="max-w-screen-xl mx-auto px-5 md:px-4 mb-8">
        <h2>{t('treatmentPage.beforeAfterPhotos.title')}</h2>
        <BeforeAfterPhotosContainer
          slug={slug}
          type={RecordType.TREATMENT}
          initialPhotos={beforeAfterPhotos}
          totalCount={baPhotosTotalCount}
        />
      </div>
    </section>
  );
};

export default BeforeAfterPhotosSection;
